import { takeLatest, all, call, put } from "typed-redux-saga/macro";

import { hostURL } from "utils/helper/states";
import { SERVICE_ACTION_TYPES } from "./service.types";
import { serviceActions } from "./service.slice";
import { FetchServices } from "./service.actions";
import { apiRequest } from "utils/helper/helper";

const getData = apiRequest;

export function* fetchDisplayData() {
  try {
    const uri = hostURL + "/api/services/get-display-services";
    const data = yield* call(getData, uri);
    if (!data) return;
    yield* put(serviceActions.setDisplayServices(data));
  } catch (error) {
    console.log(error as Error);
  }
}
export function* fetchDropdownData() {
  try {
    const uri = hostURL + "/api/services/get-service-drop-down";
    const data = yield* call(getData, uri);
    if (!data) return;
    yield* put(serviceActions.setDropdownServices(data));
  } catch (error) {
    console.log(error as Error);
  }
}
// /api/services/get-service-drop-down
export function* fetchServices({ payload: user }: FetchServices) {
  try {
    const uri = hostURL + "/api/services/get-services";
    const data = yield* call(getData, uri, user.token);
    if (!data) return;

    yield* put(serviceActions.setServices(data));
  } catch (error) {
    console.log(error as Error);
  }
}
export function* fetchServiceProviders({ payload: user }: FetchServices) {
  try {
    const uri = hostURL + "/api/services/get-service-providers";
    const data = yield* call(getData, uri, user.token);
    if (!data) return;
    console.log(data);

    yield* put(serviceActions.setServiceProviders(data));
  } catch (error) {
    console.log(error as Error);
  }
}
// /api/services/get-service-providers
export function* onFetchDisplayData() {
  yield* takeLatest(
    SERVICE_ACTION_TYPES.FETCH_DISPLAY_SERVICES,
    fetchDisplayData
  );
}
export function* onFetchDropdownData() {
  yield* takeLatest(
    SERVICE_ACTION_TYPES.FETCH_DISPLAY_SERVICES,
    fetchDropdownData
  );
}

export function* onFetchData() {
  yield* takeLatest(SERVICE_ACTION_TYPES.FETCH_SERVICES, fetchServices);
}

export function* onFetchAllProviders() {
  yield* takeLatest(
    SERVICE_ACTION_TYPES.FETCH_SERVICE_PROVIDERS,
    fetchServiceProviders
  );
}

export function* serviceSagas() {
  yield* all([
    call(onFetchDisplayData),
    call(onFetchData),
    call(onFetchAllProviders),
    call(onFetchDropdownData),
  ]);
}
